import api from "./axios";
import type { Match } from "@/types";
import { paths } from "./paths";

export const getMatches = (ended?: boolean) =>
  api
    .get<Match[]>(paths.matches.list, {
      params: ended !== undefined ? { ended: String(ended) } : {},
    })
    .then((r) => r.data);

export const getMatch = (id: string) =>
  api.get<Match>(paths.matches.one(id)).then((r) => r.data);

export const createMatch = (
  playerAssignments: { playerId: string; teamId: number }[],
) =>
  api
    .post<Match>(paths.matches.list, { playerAssignments })
    .then((r) => r.data);

export const endMatch = (id: string) =>
  api.post<Match>(paths.matches.end(id)).then((r) => r.data);
